import { render } from "./NotificationsManager.vue?vue&type=template&id=bccdf8ae&ts=true"
import script from "./NotificationsManager.vue?vue&type=script&lang=ts"
export * from "./NotificationsManager.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__